import { render } from "./JoinNowStep04SeekingAge.vue?vue&type=template&id=6c6fac5e&scoped=true"
import script from "./JoinNowStep04SeekingAge.vue?vue&type=script&lang=js"
export * from "./JoinNowStep04SeekingAge.vue?vue&type=script&lang=js"

import "./JoinNowStep04SeekingAge.vue?vue&type=style&index=0&id=6c6fac5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6fac5e"]])

export default __exports__